import React, { useState } from "react";

import ReCAPTCHA from "react-google-recaptcha";
import "../styles/Kontakt.css";
import axios from "axios";

export default function Kontakt() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [captchaValue, setCaptchaValue] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  <ReCAPTCHA
  sitekey="YOUR_GOOGLE_RECAPTCHA_SITE_KEY"
  onChange={setCaptchaValue}
/>


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!formData.name || !formData.email || !formData.message) {
      setError("Bitte füllen Sie alle Felder aus.");
      return;
    }

    if (!captchaValue) {
      setError("Bitte bestätigen Sie, dass Sie kein Roboter sind.");
      return;
    }

    try {
      const response = await axios.post("https://your-api.com/contact", formData);
      if (response.status === 200) {
        setSuccess("Ihre Nachricht wurde erfolgreich gesendet.");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setError("Fehler beim Senden der Nachricht. Bitte versuchen Sie es erneut.");
      }
    } catch (err) {
      setError("Serverfehler. Bitte versuchen Sie es später noch einmal.");
    }
  };

  return (
    <div className="kontakt-container">
      <h1 className="kontakt-title">Kontakt</h1>
      <p className="kontakt-description">Haben Sie Fragen? Schreiben Sie uns eine Nachricht.</p>
      {error && <p className="error-message">{error}</p>}
      {success && <p className="success-message">{success}</p>}

      <form onSubmit={handleSubmit} className="kontakt-form">
        <input type="text" name="name" placeholder="Ihr Name" value={formData.name} onChange={handleChange} required />
        <input type="email" name="email" placeholder="Ihre E-Mail" value={formData.email} onChange={handleChange} required />
        <textarea name="message" placeholder="Ihre Nachricht" value={formData.message} onChange={handleChange} required />
        
        <ReCAPTCHA sitekey="YOUR_GOOGLE_RECAPTCHA_KEY" onChange={setCaptchaValue} />
        <button type="submit">Nachricht senden</button>
      </form>
    </div>
  );
}
